import Vue from 'vue'

// import VideoBg from 'vue-videobg'
// import VideoBackground from 'vue-responsive-video-background-player'

import Router from 'vue-router'
import Head from 'vue-head'
//import isNil from 'lodash/isNil'
import Home from '@/views/Home'
// import CheckLogin from '@/views/CheckLogin'
//import store from '@/store'
// Vue.component('video-background', VideoBackground)
// Vue.use(VideoBackground)
// Vue.component('video-bg', VideoBg)
Vue.use(Router)

/* If you don't know about VueHead, please refer to https://github.com/ktquez/vue-head */

Vue.use(Head, {
    complement: 'Global Choices'
})

/* If you don't know about VueRouter, please refer to https://router.vuejs.org/ */

import Finance from '@/views/Finance.vue';  // Import Finance component
import Sales from '@/views/Sales.vue';  // Import Sales component

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: function (to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/digitalpath',
            name: 'digitalpath',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/DigitalPath.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/socialpath',
            name: 'socialpath',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/SocialPath.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/disabilityassist',
            name: 'disabilityassist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/DisabilityAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/TheIncentiveCompany',
            name: 'TheIncentiveCompany',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/TheIncentiveCompany.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/claimcentral',
            name: 'claimcentral',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/ClaimCentral.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/claimcentral/finance',  // New route for Finance
            name: 'finance',
            component: Finance,
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/claimcentral/sales',  // New route for Sales
            name: 'sales',
            component: Sales,
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/CallCenterAndGlobalStars',
            name: 'CallCenterAndGlobalStars',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/CallCenterAndGlobalStars.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/OurApps',
            name: 'OurApps',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/OurApps.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/AppScreensStepAssist',
            name: 'AppScreensStepAssist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/AppScreensStepAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/AppScreensCommriskAssist',
            name: 'AppScreensCommriskAssist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/AppScreensCommriskAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/AppScreensOrangeAssist',
            name: 'AppScreensOrangeAssist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/AppScreensOrangeAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/AppScreensIntegritasAssist',
            name: 'AppScreensIntegritasAssist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/AppScreensIntegritasAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/AppScreensSuperValueAssist',
            name: 'AppScreensSuperValueAssist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/AppScreensSuperValueAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },
        {
            path: '/AppScreensTWKAssist',
            name: 'AppScreensTWKAssist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/AppScreensTWKAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },        
        {
            path: '/AppScreensFrontlineAssist',
            name: 'AppScreensFrontlineAssist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/AppScreensFrontlineAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },      
        {
            path: '/24hMotorAssist',
            name: '24hMotorAssist',
            component: () =>
                import(/* webpackChunkName: "client-chunk-login" */ '@/views/24hMotorAssist.vue'),
            meta: {
                authNotRequired: true
            }
        },
        { path: '*', redirect: '/home' }
    ],
    // scrollBehavior (to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition
    //     } else {
    //         return { x: 0, y: 0 }
    //     }
    // }
})

// { 
//     path: '/check-login',
//     name: 'check-login',
//     component: CheckLogin,
//     meta: {
//         authNotRequired: true
//     }
// },
// {
//     path: '/login',
//     name: 'login',
//     component: () =>
//         import ( /* webpackChunkName: "client-chunk-login" */ '@/views/Login.vue'),
//     meta: {
//         authNotRequired: true
//     }
// }, 



/**
 * Handle user redirections
 */
//router.beforeEach((to, from, next) => {
//    if (
//        !(to.meta && to.meta.authNotRequired) &&
//        isNil(store.state.authentication.user)
//    ) {
//        //const path = store.state.authentication.user === null ? '/login' : '/check-login'
//        //return next(`${path}?redirectUrl=${to.path}`)
//    }
//    next()
//})

export default router
